import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3659a5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ts-counts" }
const _hoisted_2 = {
  key: 0,
  class: "ts-nps-bar-bg-container"
}
const _hoisted_3 = { class: "ts-nps-bar-container ts-nps-bar-bg" }
const _hoisted_4 = { class: "bar-count-right" }
const _hoisted_5 = {
  key: 1,
  class: "ts-nps-bar-bg-container"
}
const _hoisted_6 = { class: "ts-nps-bar-container ts-nps-bar-bg" }
const _hoisted_7 = { class: "bar-count-right" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ts-nps-bar positive" }, null, -1))
const _hoisted_9 = { class: "bar-count" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ts-nps-bar negative" }, null, -1))
const _hoisted_11 = { class: "bar-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormattedNumber = _resolveComponent("FormattedNumber")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showBg)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.countPositive > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", {
                    class: "ts-nps-bar positive absolute",
                    style: _normalizeStyle({ width: _ctx.countWidthPositive })
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.countPositive), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.countNegative > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", {
                    class: "ts-nps-bar negative absolute",
                    style: _normalizeStyle({ width: _ctx.countWidthNegative })
                  }, null, 4)
                ]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.countNegative), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.countPositive > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                style: _normalizeStyle({ width: _ctx.countWidthPositive }),
                class: "ts-nps-bar-container"
              }, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_FormattedNumber, { number: _ctx.countPositive }, null, 8, ["number"])
                ])
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.countNegative > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                style: _normalizeStyle({ width: _ctx.countWidthNegative }),
                class: "ts-nps-bar-container"
              }, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_FormattedNumber, { number: _ctx.countNegative }, null, 8, ["number"])
                ])
              ], 4))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}